import React, { PureComponent as Component } from 'react';
import propTypes from 'prop-types';

export default class Title extends Component{
  render(){
    return(
      <div className="with-toolbars__title">
        { this.props.children }
      </div>
    )
  }
}

Title.propTypes={
  children: propTypes.node
}